import { useSearchParams } from "react-router-dom";
import { Wallet } from "lucide-react";
import { CobrosCiudad } from "@/components/midinero/CobrosCiudad";
import { Liquidaciones } from "@/components/midinero/Liquidaciones";
import { TodosHoja } from "@/components/midinero/TodosHoja";
import { AnticiposHoja } from "@/components/midinero/AnticiposHoja";

const HOJAS = [["ciudad", "Cobros de Ciudad"], ["departamentos", "Liquidaciones de Departamentos"], ["todos", "Todos"], ["anticipos", "Anticipos"]];

export default function MiDinero() {
  const [sp, setSp] = useSearchParams();
  const hoja = sp.get("hoja") || "ciudad";
  return (
    <div className="space-y-4" data-testid="mi-dinero-page">
      <div className="flex items-center gap-3">
        <Wallet className="w-10 h-10 text-amber-500" />
        <div>
          <h1 className="font-black tracking-tight text-3xl">Mi Dinero</h1>
          <p className="text-sm text-zinc-600">Control de cobros, bancos y facturación</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 print:hidden">
        {HOJAS.map(([k, l]) => (
          <button key={k} onClick={() => setSp({ hoja: k })} data-testid={`hoja-${k}`}
            className={`rounded-xl px-4 py-2 text-sm font-black border-2 transition-colors ${hoja === k ? "bg-violet-700 text-white border-violet-700" : "bg-white text-violet-800 border-violet-200 hover:border-violet-500"}`}>
            {l}
          </button>
        ))}
      </div>
      {hoja === "ciudad" && <CobrosCiudad />}
      {hoja === "departamentos" && <Liquidaciones />}
      {hoja === "todos" && <TodosHoja />}
      {hoja === "anticipos" && <AnticiposHoja />}
    </div>
  );
}
